module.exports = __webpack_public_path__ + "media/images/flags/MF-5a5df77f1edf566126ebd3f7861a3146.svg";